
import React from 'react'
import {Router, useRouterHistory} from 'dva/router'
import { createHashHistory } from 'history';
import { LocaleProvider } from 'antd';
import es_ES from 'antd/lib/locale-provider/es_ES';

import App from './components/app'
import Dashboard from './components/dashboard'
import Profile from './components/profile'

import Hotel from './components/hotels'
import HotelNew from './components/hotels/hotelNew'

import Client from './components/clients'
import ClientNew from './components/clients/clientNew'

import Manager from './components/managers'
import ManagerNew from './components/managers/managerNew'

import User from './components/users'
import UserNew from './components/users/userNew'

import Employee from './components/employees'
import EmployeeNew from './components/employees/employeeNew'

import Invoice from './components/invoices'
import InvoiceNew from './components/invoices/invoiceNew'

import Receptionist from './components/receptionists'
import ReceptionistNew from './components/receptionists/receptionistNew'

import ExpensesType from './components/catalogs/expenses'
import PaymentsType from './components/catalogs/payments'
import AdonsType from './components/catalogs/adons'

import ContaDashboard from './components/incomes/contaDashboard'
import CashFund from './components/incomes/cashFunds'
import CashFundRequest from './components/incomes/cashFundsRequests'
import IncomeReport from './components/incomes/incomeReport'
import Payment from './components/incomes/payments'
import Commission from './components/incomes/commissions'
import Payroll from './components/incomes/payroll'
import Total from './components/incomes/totals'

import Adon from './components/adons'
import AdonNew from './components/adons/adonNew'

import Config from './components/config/config'

export default function ({history}) {
    const routes = [
        {
            path: '/',
            component: App,
            getIndexRoute(nextState, cb) {
                require.ensure([], require => {
                    cb(null, {component: Dashboard})
                })
            },
            childRoutes: [
                {
                    path: '/hotels',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Hotel)
                        })
                    }
                },
                {
                    path: '/hotels/new-hotel',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, HotelNew)
                        })
                    }
                },
                {
                    path: '/hotels/details/:hotelId',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, HotelNew)
                        })
                    }
                },
                {
                    path: '/all_users/list-managers',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Manager)
                        })
                    }
                },
                {
                    path: '/managers/new-manager',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, ManagerNew)
                        })
                    }
                },
                {
                    path: '/managers/details/:managerId',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, ManagerNew)
                        })
                    }
                },
                {
                    path: '/all_users/list-receptionists',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Receptionist)
                        })
                    }
                },
                {
                    path: '/receptionists/new-receptionist',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, ReceptionistNew)
                        })
                    }
                },
                {
                    path: '/receptionists/details/:receptionistId',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, ReceptionistNew)
                        })
                    }
                },
                {
                    path: '/clients',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Client)
                        })
                    }
                },
                {
                    path: '/clients/new-client',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, ClientNew)
                        })
                    }
                },
                {
                    path: '/clients/details/:clientId',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, ClientNew)
                        })
                    }
                },
                {
                    path: 'employees',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Employee)
                        })
                    }
                },
                {
                    path: '/employees/new-employee',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, EmployeeNew)
                        })
                    }
                },
                {
                    path: '/employees/details/:employeeId',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, EmployeeNew)
                        })
                    }
                },
                {
                    path: '/all_users/list-users',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, User)
                        })
                    }
                },
                {
                    path: '/users/new-user',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, UserNew)
                        })
                    }
                },
                {
                    path: '/users/details/:userId',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, UserNew)
                        })
                    }
                },
                {
                    path: '/invoices/list-invoices',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Invoice)
                        })
                    }
                },
                {
                    path: '/invoices/new-invoice(/:clientId)',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, InvoiceNew)
                        })
                    }
                },
                {
                    path: '/invoices/details/:invoiceId',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, InvoiceNew)
                        })
                    }
                },
                {
                    path: '/adons/list-adons',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Adon)
                        })
                    }
                },
                {
                    path: '/adons/new-adon',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, AdonNew)
                        })
                    }
                },
                {
                    path: '/adons/details/:adonId',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, AdonNew)
                        })
                    }
                },
                {
                    path: '/catalogs/expenses_type',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, ExpensesType)
                        })
                    }
                },
                {
                    path: '/catalogs/payments_type',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, PaymentsType)
                        })
                    }
                },
                {
                    path: '/catalogs/adons_type',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, AdonsType)
                        })
                    }
                },
                {
                    path: '/conta/:contaType',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, ContaDashboard)
                        })
                    }
                },
                {
                    path: '/incomes/cash_funds/:incomeType',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, CashFund)
                        })
                    }
                },
                {
                    path: '/incomes/cash_funds_requests/:incomeType',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, CashFundRequest)
                        })
                    }
                },
                {
                    path: '/incomes/incomes_report/:incomeType/:date',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, IncomeReport)
                        })
                    }
                },
                {
                    path: '/incomes/payments/:incomeType',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Payment)
                        })
                    }
                },
                {
                    path: '/incomes/payroll/:incomeType',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Payroll)
                        })
                    }
                },
                {
                    path: '/incomes/commissions/:incomeType',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Commission)
                        })
                    }
                },
                {
                    path: '/incomes/totals',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Total)
                        })
                    }
                },
                {
                    path: '/config',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Config)
                        })
                    }
                },
                {
                    path: '/profile',
                    getComponent(nextState, cb) {
                        require.ensure([], require => {
                            cb(null, Profile)
                        })
                    }
                },
            ]
        }
    ]

    const appHistory = useRouterHistory(createHashHistory)({ queryKey: false })
    return <LocaleProvider locale={es_ES}><Router history={appHistory} routes={routes} /></LocaleProvider>
}


// WEBPACK FOOTER //
// ./src/router.js